import * as React from "react";
import {SVGProps} from "react";
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 14 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M13.088 4.814a.597.597 0 0 0-.5-.678l-3.617-.53L7.359.34a.594.594 0 0 0-1.073 0L4.675 3.606l-3.612.528A.597.597 0 0 0 .73 5.153l2.615 2.545-.616 3.596a.596.596 0 0 0 .865.635l3.235-1.703 3.222 1.703a.59.59 0 0 0 .392.06.595.595 0 0 0 .482-.695l-.621-3.596 2.614-2.548a.595.595 0 0 0 .17-.336h.001Z" />
    </svg>
);
export default SvgStar;
